import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';
import dayjs from 'dayjs';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }),
};
@Injectable({ providedIn: 'root' })

/**headers: new HttpHeaders({'Content-Type': 'application/json',}),
 * Auth-service Component
 */
export class AuthenticationService {
	user!: User;
	currentUserValue: any;
	url: string = '';
	constructor(private http: HttpClient) {}

	/**
	 * Performs the register
	 * @param email email
	 * @param password password
	 */
	register(email: string, password: string) {
		return getFirebaseBackend()!
			.registerUser(email, password)
			.then((response: any) => {
				const user = response;
				return user;
			})
			.catch((response) => {
				throw response;
			});
	}

	/**
	 * Performs the auth
	 * @param email email of user
	 * @param password password of user
	 */
	login(email: string, password: string) {
		return getFirebaseBackend()!
			.loginUser(email, password)
			.then((response: any) => {
				const user = response;
				return user;
			});
	}

	/**
	 * Returns the current user
	 */
	public currentUser(): any {
		return getFirebaseBackend()!.getAuthenticatedUser();
	}

	/**
	 * Logout the user
	 */
	logout() {
		// logout the user
		return getFirebaseBackend()!.logout();
	}

	/**
	 * Reset password
	 * @param email email
	 */
	resetPassword(email: string) {
		// getFirebaseBackend()!.forgetPassword(email);
		return getFirebaseBackend()!
			.forgetPassword(email)
			.then(
				(response: any) => {
					const message = response.data;
					return message;
				},
				(rejectionReason) => {
					alert(rejectionReason);
				},
			)
			.catch((e) => {
				console.info('respuesta error: reset password:' + e);
			});
	}

	verifyPassword(code: string) {
		return getFirebaseBackend()!.verifyCodePassword(code);
	}

	confirmPassword(code: string, password: string) {
		return getFirebaseBackend()!.confirmPassword(code, password);
	}

	refreshToken() {
		return getFirebaseBackend()?.refreshToken();
	}

	getLmsUserData(email: string) {
		this.url = `${environment.api}user/get_lms_data/${email}`;
		return this.http.get(this.url);
	}

	getLmsCustomerData(email: string) {
		this.url = `${environment.api}user/${email}/change_customer_data`;
		return this.http.get(this.url);
	}

	async getIpPublicNetwork() {
		let ipInfo: any = {};

		const ipProviders = ['https://ipapi.co/json/', 'https://api.ipify.org/?format=json', 'https://bigdatacloud.net/data/client-ip', 'https://us1.api-bdc.net/data/client-info'];

		for (const provider of ipProviders) {
			try {
				const response: any = await this.http.get(provider).toPromise();
				if (response && response.ip && this.isValidIp(response.ip)) {
					ipInfo = response;
					ipInfo.ipv4 = response.ip;
					break;
				}
			} catch (error) {
				// Se ignora el error de este provider y se continúa con el siguiente
				console.info(`Error fetching IP from ${provider}:`, error);
			}
		}

		return ipInfo;
	}

	isValidIp(ip: string) {
		if (!/^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/.test(ip)) {
			console.error('Invalid IP address:', ip);
			return false;
		}
		return true;
	}

	saveLogin(userId: number, ip: any) {
		console.info('datos a enviar de historia inicio', userId, ip);
		var formData: any = new FormData();
		formData.append('user_id', userId);
		formData.append('ipv4', ip.ipv4);
		formData.append('signin_time', dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
		formData.append('ipv6', ip.ipv6);
		formData.append('country', ip.country);
		formData.append('country_area', ip.country_area);
		formData.append('country_code', ip.country_code);
		formData.append('region', ip.region);
		formData.append('region_code', ip.region_code);
		formData.append('city', ip.city);
		formData.append('latitude', ip.latitude);
		formData.append('longitude', ip.longitude);
		formData.append('timezone', ip.timezone);
		formData.append('zip', ip.postal);
		formData.append('org', ip.org);

		console.info('datos a enviar de historia', dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'));
		this.url = `${environment.api}user/save_login`;
		var prueba = this.http.post(this.url, formData);
		return prueba;
	}

	verifyMasterLogin(email: string, password: string) {
		var formData: any = new FormData();
		formData.append('email', email);
		formData.append('password', password);

		this.url = `${environment.api}user/verify_master_login`;
		return this.http.post(this.url, formData);
	}
}
